import { useContext } from "react";

import { usePrevious } from "@swa-ui/application";

import { AuthContext } from "../AuthProvider";

/**
 * Returns true if user was logged in or had limited access, and has just logged out.
 */

export const useIsJustLoggedOut = () => {
  const { isLoggedIn, isLimitedAccess } = useContext(AuthContext);
  const limitedAccess = isLimitedAccess();
  const loggedIn = isLoggedIn();
  const authorized = loggedIn || limitedAccess;
  const previouslyLoggedIn = usePrevious(authorized) ?? false;

  return previouslyLoggedIn && !authorized;
};
